import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import H1 from '../../../atoms/title/H1';
import Notice from '../../../molecules/Notice';
import PaginationList from '../../../molecules/PaginationList';
import Layout from '../../../templates/Layout';
import { useTranslation } from 'react-i18next';
import { CopyrightCheckerPhotoOverviewTable } from '../../../organisms/table/CopyrightCheckerPhotoOverviewTable';
export const CopyrightCheckerPhotoOverviewView = ({ notice, loading, data, resData, setPage, }) => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('copyright_checker.photo.overview_title') }) }), notice && _jsx(Notice, { ...notice }), _jsx(H1, { children: t('copyright_checker.photo.overview_title') }), _jsx(CopyrightCheckerPhotoOverviewTable, { loading: loading, data: data }), _jsx(PaginationList, { disabled: loading, links: resData.links, setPage: setPage })] }));
};
